$(document).ready(function() {
  $('body').scrollspy({ target: '.navigation-bar' });

  $(window).scroll(function() {
    var $feedback = $('.feedback');
    var $limitSection = $('#doing-good-on-the-ground');
    var $isInitiallyHidden = $('.feedback').hasClass('initial-hidden');

    if ($feedback.length &&
        $limitSection.length &&
        $isInitiallyHidden &&
        $(window).scrollTop() > $limitSection.offset().top) {
      $feedback.removeClass('initial-hidden');
    }
  });
});
